<mat-card appearance="outlined">
    <mat-card-content>
        <div class="flex-container">
            <div class="static-text-container">
                <p class="label">{{ '@name' | translate }}</p>
                <span class="text">{{vehicle.name}}</span>
            </div>
            <div class="static-text-container">
                <p class="label">{{ '@vin' | translate }}</p>
                <span class="text">{{vehicle.vin}}</span>
            </div>
            <div class="static-text-container" *ngIf="vehicle.engineVin && vehicle.engineVin !== vehicle.vin">
                <p class="label">{{ '@engineVin' | translate }}</p>
                <span class="text">{{vehicle.engineVin}}</span>
            </div>
            <div class="static-text-container">
                <p class="label">{{ '@make' | translate }}</p>
                <span class="text">{{vehicle.make}}</span>
            </div>
            <div class="static-text-container">
                <p class="label">{{ '@model' | translate }}</p>
                <span class="text">{{vehicle.model}}</span>
            </div>
            <div class="static-text-container">
                <p class="label">{{ '@year' | translate }}</p>
                <span class="text">{{vehicle.modelYear}}</span>
            </div>
            <div class="static-text-container">
                <p class="label">{{ '@bodyClass' | translate }}</p>
                <span class="text">{{vehicle.bodyClass}}</span>
            </div>
            <div class="static-text-container" *ngIf="vehicle.buildConfiguration.vehicleType">
                <p class="label">{{ '@type' | translate }}</p>
                <span class="text">{{vehicle.buildConfiguration.vehicleType}}</span>
            </div>
            <div class="static-text-container" *ngIf="vehicle.buildConfiguration.axles">
                <p class="label">{{ '@axles' | translate }}</p>
                <span class="text">{{vehicle.buildConfiguration.axles}}</span>
            </div>
            <div class="static-text-container" *ngIf="displayOdometer !== '0'">
                <p class="label">{{ '@odometer' | translate }}</p>
                <span class="text">{{displayOdometer}}</span>
            </div>
            <div class="static-text-container" *ngIf="displayOperationDuration !== '0'">
                <p class="label">{{ '@engineHours' | translate }}</p>
                <span class="text">{{displayOperationDuration}}</span>
            </div>
            <div class="static-text-container">
                <p class="label">{{ '@createdDate' | translate }}</p>
                <span class="text">{{vehicle?.createDateTimeUtc | localizedDate: 'short'}}</span>
            </div>
            <div class="static-text-container clickable" *ngIf="vehicleState?.updateDateTimeUtc"
                (click)="showDateDetails()">
                <p class="label">{{ '@lastUpdated' | translate }}</p>
                <div class="icon-with-text text-left">
                    <span class="text">{{vehicleState?.updateDateTimeUtc | localizedDate: 'short'}}</span>                    
                    <mat-icon matSuffix>
                        calendar_month
                    </mat-icon>
                </div>

            </div>
            <div class="static-text-container clickable" *ngIf="telematicDriver$ | async; let telematicDriver"
                (click)="showDriverDetails(telematicDriver)">
                <p class="label">{{ '@driverStatus' | translate }}</p>
                <span class="text">{{displayDriverDict(telematicDriver)}}</span>
            </div>
        </div>
    </mat-card-content>
</mat-card>